import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import type { DialogConfig } from '@/v2/framework/dialog/types'
import { notify, notifyApiError } from '@/v2/notifications'
import { NXGDSStatusVariant } from '@nsftx/seven-nxg-design-system-backoffice'

export function createDeleteDialog(options: { roundsApi: TournamentRoundsApi }): DialogConfig {
  const { roundsApi } = options

  return {
    id: 'delete-tournament-round',
    title: 'Delete tournament round',
    description: 'Are you sure you want to delete this tournament round?',
    layout: {
      type: 'nxgds-dialog',
      actions: [
        { intent: 'dismiss', label: 'Cancel', variant: 'secondary' },
        { intent: 'submit', label: 'Delete', variant: 'danger' },
      ],
    },
    structure: {
      type: 'flat',
      children: [],
    },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await roundsApi.delete(dialogCtx.row?.id)
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" tournament round.`,
          })
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" tournament round.`)
        }
      },
    },
  }
}
